(() => {
  document.addEventListener('click', event => {
    if (!event.target?.closest?.('cart-drawer .drawer__close, #CartDrawer .drawer__close, cart-drawer .cart-drawer__overlay, #CartDrawer .cart-drawer__overlay')) return;
    const root = document.querySelector(".oh-egypt-order[data-checkout-mode='cart']");
    if (!root) return;
    const hadLoaded = root.hasAttribute('data-loaded');
    const previousLoaded = root.dataset.loaded;
    root.dataset.loaded = '1';
    setTimeout(() => {
      if (!root.isConnected) return;
      if (hadLoaded) root.dataset.loaded = previousLoaded || '';
      else root.removeAttribute('data-loaded');
    }, 0);
  }, true);
})();
